<template>
    <div class="col-sm-12">
        <reservations-tabs :selected="selectedTab" @update:selected="selectedTab = $event" />

        <div v-if="selectedTab === 'reservations'" class="bg-lightest reservations-panel py-4 mt-0 reservations-min-height">
        <!-- Controls slot (filters/search area) -->
        <slot name="controls">
            <div class="options d-flex align-items-center my-3 pl-3">
                <div class="col-sm-12">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="d-flex col-sm-4 pl-0">
                                    <div class="d-flex w-100">
                                        <input class="bg-lighter flexGrow1" type="text" v-model="$parent.filters.searchString" @input="$parent.onFilterChange" placeholder="Search customer, ticket, voucher">
                                        <button class="btn wider blue ml-3 w-80" @click="$parent.onFilterChange">Search</button>
                                    </div>
                                </div>

                                <div class="col-sm-4 d-flex pl-0 align-items-center">
                                    <button class="btn wider bg-dark ml-1" v-if="$parent.getShowInvoiceOption === true && ($parent.getBulkSelectedIds.length > 0 || $parent.bulkSelectAll)" @click="$parent.openOptions">Invoice ({{$parent.bulkInvoiceTotal}})</button>
                                </div>

                                <div class="col-sm-4 d-flex justify-content-end align-items-center pr-0">
                                    <export :exportOptions="$parent.exportOptions"></export>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 mt-3">
                            <div class="row d-flex align-items-start">
                                <div class="d-flex flexGrow1">
                                    <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="$parent.getSlimFilters">
                                        <multiselect
                                            ref="productFilter"
                                            v-model="$parent.filters.productId"
                                            :options="$parent.treatedProductList"
                                            :multiple="true"
                                            :close-on-select="false"
                                            :clear-on-select="false"
                                            :preserve-search="false"
                                            placeholder="All Products"
                                            label="name"
                                            track-by="id"
                                            selectLabel=""
                                            deselectLabel=""
                                            selectedLabel=""
                                            class="w-100"
                                            @input="$parent.onFilterChange"
                                        >

                                            <template slot="selection" slot-scope="{ values }">
                                                <span class="multiselect__single" v-if="values.length > 1" v-tooltip.auto="values.length + ' products selected'">{{ values.length }} products selected</span>
                                                <span class="multiselect__single" v-else-if="values.length == 1 " v-tooltip.auto="values[0].name">{{values[0].name}} </span>
                                            </template>

                                            <template slot="option" slot-scope="props">
                                                <i v-if="$parent.filters.productId.filter(i => {return i.id == props.option.id}).length" class="far fa-check-square"></i>
                                                <i v-else class="far fa-square"></i>
                                                <span v-tooltip.auto="props.option.name">{{props.option.name}}</span>
                                            </template>
                                        </multiselect>
                                    </div>

                                    <div class="col-md-2 d-flex flex-row align-items-center pl-0">
                                        <multiselect
                                            ref="locationFilter"
                                            v-model="$parent.filters.locations"
                                            :options="$parent.locations"
                                            :multiple="true"
                                            :close-on-select="false"
                                            :clear-on-select="false"
                                            :preserve-search="false"
                                            track-by="id"
                                            label="name"
                                            selectLabel=""
                                            deselectLabel=""
                                            selectedLabel=""
                                            class="w-100"
                                            placeholder="All Locations"
                                            @input="$parent.onFilterChange"
                                        >

                                            <template slot="selection" slot-scope="{ values }">
                                                <span class="multiselect__single" v-if="values.length > 1" v-tooltip.auto="values.length + ' locations selected'">{{ values.length }} locations selected</span>
                                                <span class="multiselect__single" v-else-if="values.length == 1 " v-tooltip.auto="values[0].name">{{values[0].name}} </span>
                                            </template>

                                            <template slot="option" slot-scope="props">
                                                <i v-if="$parent.filters.locations.filter(i => {return i.name == props.option.name}).length" class="far fa-check-square"></i>
                                                <i v-else class="far fa-square"></i>
                                                <span v-tooltip.auto="props.option.name">{{props.option.name}}</span>
                                            </template>
                                        </multiselect>
                                    </div>

                                    <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="$parent.editedAgentList && $parent.editedAgentList.length > 0">
                                        <seller-picker 
                                            class="w-100" 
                                            ref="sellerSelector" 
                                            :inlcudeWidget="true" 
                                            placeholder="All Sellers" 
                                            @input="$parent.sellerChanged" 
                                            @deselect="$parent.deselectSeller"
                                            :optionsType="'new'">
                                        </seller-picker>
                                    </div>

                                    <div class="d-flex pr-4">
                                        <button class="btn tertiary reservations-filters-height d-flex align-items-center justify-content-center position-relative" @click="$parent.openFilters(1)">
                                            <i class="fas fa-sliders-h fs-large"></i>
                                            <span>More Filters</span>
                                            <div class="reservations-filters-circle bg-color-1" v-show="$parent.hasSelectedReservationFilters"></div>
                                        </button>
                                    </div>

                                    <div class="reservations-filters-height d-flex align-items-center">
                                        <checkbox v-model="$parent.filters.currentCheckboxNoCheckin" @input="$parent.resetPagination">
                                            <span class="white-space-nowrap">No Checkin</span>
                                        </checkbox>
                                    </div>
                                </div>

                                <div>
                                    <div class="d-flex flex-row align-items-center pr-3">
                                        <button class="btn tertiary reservations-filters-height" @click="$parent.clearFilters">Clear All</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </slot>

        <!-- Top pagination -->
        <div class="col-sm-12 d-flex justify-content-between my-4" v-if="hasLoadedOnce">
            <div class="bold dark">
                <span v-if="allowSelectRows && pageInfo && rows && rows.length > 0">Selected {{bulkInvoiceTotal}} of {{pageInfo.totalItemCount}} | </span>
                <span>Results per page:</span>
                <select :value="resultsPerPage" @change="$emit('results-per-page-change', Number($event.target.value))" class="results-per-page border-light">
                    <option v-for="option in resultsPerPageOptions" :key="option.pSize" :value="option.pSize">
                        {{ option.pSizeText }}
                    </option>
                </select>
            </div>
            <div>
                <uib-pagination
                    v-if="pageInfo && pageInfo.pageCount > 1"
                    :value="paginationValue"
                    :total-items="pageInfo.totalItemCount"
                    :items-per-page="resultsPerPage"
                    :boundary-link-numbers="false"
                    :max-size="7"
                    @input="onPageChange"
                ></uib-pagination>
            </div>
        </div>

        <!-- List -->
        <list v-if="!isLoading && rows" :header="header" :body="body" :rows="rows" :showNoDataMessage="false" class="px-3"></list>

        <!-- Bottom pagination -->
        <div class="col-sm-12 d-flex justify-content-end my-4" v-if="pageInfo && rows && rows.length > 0">
            <uib-pagination
            v-if="pageInfo.pageCount > 1"
            :value="paginationValue"
            :total-items="pageInfo.totalItemCount"
            :items-per-page="resultsPerPage"
            :boundary-link-numbers="false"
            :max-size="7"
            @input="onPageChange"
            ></uib-pagination>
        </div>

        <div v-if="!isLoading && hasLoadedOnce && rows && rows.length == 0" class="text-center p-4 mt-5">
            <span class="dark font-weight-600 fs-large">No reservations found</span>
        </div>

        <div v-if="isLoading || !hasLoadedOnce" class="p-4 my-5 text-center">
            <loader></loader>
        </div>
        </div>

        <div v-else>
            <payment-links />
        </div>
    </div>
</template>

<script>
import ReservationsTabs from '@/components/reservations/ReservationsTabs'
import PaymentLinks from '@/components/reservations/PaymentLinks'
import { eventHub } from '@/main'
import List from '@/tools/list/baseList'
import Loader from '@/tools/loaders/loader1'
import Multiselect from 'vue-multiselect'
import Export from '@/tools/ExportV2'
import SellerPicker from '@/tools/SellerPicker'

export default {
    name: 'ReservationsWrapper',
    data() {
        return {
            selectedTab: this.initialTab
        }
    },
    watch: {
        selectedTab(newVal) {
        eventHub.$emit('reservations:selectedTab', newVal);
        }
    },
    props: {
        rows: { type: Array, default: () => [] },
        initialTab: { type: String, default: 'reservations' },
        isLoading: { type: Boolean, default: false },
        hasLoadedOnce: { type: Boolean, default: false },
        pageInfo: { type: Object, default: () => null },
        header: { type: Object, default: () => ({}) },
        body: { type: Object, default: () => ({}) },
        paginationValue: { type: Object, default: () => ({}) },
        resultsPerPage: { type: Number, default: 20 },
        resultsPerPageOptions: { type: Array, default: () => [] },
        allowSelectRows: { type: Boolean, default: false },
        bulkInvoiceTotal: { type: Number, default: 0 }
    },
    components: { ReservationsTabs, PaymentLinks, List, Loader, Multiselect, Export, SellerPicker },
    methods: {
        onPageChange(pagination) {
        this.$emit('page-change', pagination.currentPage);
        }
    }
}
</script>



// WEBPACK FOOTER //
// ReservationsWrapper.vue?61644a39